import * as STD from '@emersya/mpa-std';
import {InputNumber} from '@emersya/mpa-components';
import EngineModule from '../EngineModule';
import {
	IPlannerDimensionsEditorComponentConfiguration
} from '../components/viewer/planner/DimensionsEditor/PlannerDimensionsEditor';

export default () => EngineModule.all.find(x => x.id === 'viewer-planner-dimensionsEditor') || new EngineModule.UIEngineModule({
	type: 'ui',
	id: 'viewer-planner-dimensionsEditor',
	useFullWidth: false,
	allowedCustomers: null,
	dependencies: [
		'viewer-planner',
		'oms-basket'
	],
	modulesBefore: ['product-editor', 'viewer-planner-layout-editor'],
	modulesAfter: ['viewer-planner-furniture-editor'],
	usableCondition: {
		type: 'and',
		LHS: {
			type: 'notequal',
			component: 'K.basket',
			property: 'TARGET.basket.currentProduct',
			value: null
		},
		RHS: {
			type: 'or',
			LHS: {
				type: 'notequal',
				component: 'K.basket',
				property: '[*]TARGET.basket.currentProduct.hasPart(["layout"])',
				value: true
			},
			RHS: {
				type: 'notequal',
				component: 'K.basket',
				property: '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption',
				value: null
			}
		}
	},
	displayCondition: {
		type: 'equal',
		component: 'K',
		property: '[*]TARGET.isDimensionEditorDisplayed',
		value: true
		// STANDING CODE
		// type: 'or',
		// 	LHS: {*+
		// 		type: 'equal',
		// 		component: 'K',
		// 		property: '[*]TARGET.hasThisModuleUsed("standing-customerMode")',
		// 		value: false
		// 	},
		// 	RHS: {
		// 		type: 'notequal',
		// 		component: 'K',
		// 		property: '[*]TARGET.parameters.mode',
		// 		value: 'client'
		// 	}
	},
	generateComponentConfiguration() {
		const config = this.configuration;
		if (!this.translations.width) {
			throw STD.errors.user('', {module: this});
		}
		if (!this.translations.depth) {
			throw STD.errors.user('', {module: this});
		}
		if (!this.translations.height) {
			throw STD.errors.user('', {module: this});
		}
		config['increment'] = Number.parseFloat(config['increment']);
		const out: IPlannerDimensionsEditorComponentConfiguration = {
			increment: config['increment'],
			'@innerConfigurations': {
				width: {
					'@translations': {
						label: this.translations.width
					},
					'@innerConfigurations': {
						range: <InputNumber.Configuration>{
							defaultValue: config['width-default'],

							// max: config['width-max'],
							// min: config['width-min'],
							getMin: {
								type: 'read',
								componentPath: 'K',
								propertyPath: 'currentProduct.metaData.PMS.dimensions.width.min'
							},
							getMax: {
								type: 'read',
								componentPath: 'K',
								propertyPath: 'currentProduct.metaData.PMS.dimensions.width.max'
							},
							renderingMode: 'textual',
							step: config.increment
						}
					}
				},
				depth: {
					'@translations': {
						label: this.translations.depth
					},
					'@innerConfigurations': {
						range: <InputNumber.Configuration>{
							defaultValue: config['depth-default'],
							getMin: {
								type: 'read',
								componentPath: 'K',
								propertyPath: 'currentProduct.metaData.PMS.dimensions.depth.min'
							},
							getMax: {
								type: 'read',
								componentPath: 'K',
								propertyPath: 'currentProduct.metaData.PMS.dimensions.depth.max'
							},
							renderingMode: 'textual',
							step: config.increment
						}
					}
				},
				height: {
					'@translations': {
						label: this.translations.height
					},
					'@innerConfigurations': {
						range: <InputNumber.Configuration>{
							/** @TODO: Break TotalExpo app, investigation needed but not today. **/
							// defaultValue: config['height-default'],
							getMin: {
								type: 'read',
								componentPath: 'K',
								propertyPath: 'currentProduct.metaData.PMS.dimensions.height.min'
							},
							getMax: {
								type: 'read',
								componentPath: 'K',
								propertyPath: 'currentProduct.metaData.PMS.dimensions.height.max'
							},
							renderingMode: 'slider',
							step: config.increment
						}
					}
				}
			},
		};
		return out;
	}
});
